var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86B197DC-7A2D-4CA3-A354-4BBC67F242AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.50290135
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-PDF-Popup",
    transform: "translate(-1187.000000, -96.000000)",
    fill: "#010101",
    stroke: "#000000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(654.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(522.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.31,15.34 L15.31,9.76 C15.31,9.38 15.62,9.07 16.01,9.07 C16.39,9.07 16.71,9.38 16.71,9.76 L16.71,16.04 C16.71,16.42 16.4,16.73 16.01,16.73 L16.01,16.73 L16.01,16.73 L0.69,16.73 L0.69,16.73 L0.69,16.73 C0.5,16.73 0.32,16.65 0.2,16.53 C0.07,16.4 0,16.23 0,16.04 L0,16.04 L0,16.04 L0,0.71 L0,0.71 L0,0.71 C0,0.33 0.31,0.01 0.69,0.01 L6.97,0.01 C7.35,0.01 7.66,0.32 7.66,0.71 C7.66,1.09 7.35,1.41 6.97,1.41 L1.39,1.41 L1.39,15.34 L15.31,15.34 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.31,2.39 L6.35,11.35 C6.08,11.62 5.64,11.63 5.36,11.35 C5.09,11.08 5.09,10.64 5.36,10.36 L14.32,1.4 L11.82,1.4 C11.44,1.4 11.13,1.09 11.13,0.7 C11.13,0.32 11.44,0 11.82,0 L16,0 C16.19,0 16.36,0.08 16.49,0.2 C16.62,0.33 16.69,0.5 16.69,0.69 L16.69,4.87 C16.69,5.25 16.38,5.56 15.99,5.56 C15.61,5.56 15.29,5.25 15.29,4.87 L15.29,2.39 L15.31,2.39 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.532ed071dff7fe4b72431912bc0eee73.svg";
export { ForwardRef as ReactComponent };